import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { reduxForm } from 'redux-form';
import AutoCompleteInput from 'components/Common/Inputs/AutoCompleteInput';
import { toastr } from 'react-redux-toastr';

class AddFormToAccountForm extends Component {
  static propTypes = {
    onConfirmFormLink: PropTypes.func.isRequired,
    accountId: PropTypes.number
  };

  static defaultProps = {
    accountId: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      formId: 0,
      formName: ''
    };

    this.onDataInputChange = this.onDataInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  onFormSelectedItem = lookupValue => lookupValue && this.setState({ formId: lookupValue.id, formName: lookupValue.value });

  onDataInputChange(event) {
    const { target: { name, value } } = event;
    this.setState({ [name]: value });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { formId } = this.state;
    const { onConfirmFormLink } = this.props;

    if (!formId || formId <= 0) {
      toastr.error('', 'Please select a form to link.');
      return;
    }

    onConfirmFormLink(formId);
    this.setState({ formId: 0, formName: '' });
  }

  render() {
    const { formName } = this.state;
    const { accountId } = this.props;
    return (
      <div className="col-12">
        <form onSubmit={ this.handleSubmit }>
          <table>
            <tbody>
              <tr>
                <td>
                  <div>
                    <label
                      htmlFor="account_number"
                      className="panel-body-label"
                    >
                      Form to Link:
                    </label>
                  </div>
                </td>
                <td>
                  <AutoCompleteInput
                    id="uploaded_form"
                    name="formId"
                    category="entityName"
                    placeholder="Enter entity name..."
                    className="form-select"
                    required
                    context={ accountId != null ? { type: 'account', id: accountId, value: '' } : null }
                    value={ formName || '' }
                    onSelectedItem={ lookupValue => this.onFormSelectedItem(lookupValue) }
                  />
                </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>
                  <button
                    id="link-form-btn"
                    className="btn btn-primary"
                    type="submit"
                  >Link Form</button>
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'addFormToAccountForm'
})(AddFormToAccountForm);
